import { Box, styled } from '@mui/material';
import { Container as AppointmentFormContainer } from 'components/mrp/components/AppointmentForm/AppointmentFormContainer.styles';
import { IconButton } from 'components/mrp/components/AppointmentForm/AppointmentForm.styles';

export const DrawerContainer = styled(AppointmentFormContainer)({
  width: '480px',
  display: 'flex',
  flexDirection: 'column'
});

export const DrawerHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(3)
}));

export const DrawerContent = styled(Box)({
  flex: 1,
  overflowY: 'auto'
});

export const DrawerActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(2),
  paddingTop: theme.spacing(3),
  borderTop: `1px solid ${theme.palette.divider}`
}));

export const SelectedParticipantRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'markedForRemoval'
})<{ markedForRemoval?: boolean }>(({ theme, markedForRemoval }) => ({
  padding: theme.spacing(1),
  paddingLeft: theme.spacing(2),
  marginBottom: theme.spacing(1),
  backgroundColor: markedForRemoval
    ? theme.palette.error.light + '20'
    : theme.vars.palette.Button.inheritContainedHoverBg,
  borderRadius: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  textDecoration: markedForRemoval ? 'line-through' : 'none',
  opacity: markedForRemoval ? 0.6 : 1,
  transition: 'all 0.2s ease'
}));

export const ParticipantActionButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: 'transparent',
  height: `calc(36px - ${theme.spacing(1)})`
}));
